<div class="flex-left-column light-control-host">
  <div class="modal-header">
    <h3 class="panel-title">Unquarantine resources for "{{ !!application ? application.name : '' }}"</h3>
    <button
      type="button"
      class="modal-close-btn"
      (click)="closeDialog()"
      pTooltip="Close"
      tooltipPosition="left"
      aria-label="Close"
    >
      <svg lucideX></svg>
    </button>
  </div>
  <div class="modal-subtitle">
    The following resources are quarantined, or isolated from the rest of your environment. You can select resources to
    <strong class="font-semibold">unquarantine</strong>, this will restore network connectivity to those resources. For
    more information, you can refer to the
    <a href="{{ ransomwareDocsUrl }}" target="_blank">ransomware-recovery documentation</a>.
  </div>

  <div class="flex-center-row full-width margin-top">
    <table id="resourceSelectionList" class="light-content-panel dialog-selection-list spacer">
      @for (resource of resources; track resource) {
        <tr>
          <td class="box-column">
            <input
              id="resource-arn"
              class="arpio-checkbox"
              type="checkbox"
              (input)="toggleResourceSelection(resource.resourceArn)"
              [checked]="resourceIsChecked(resource.resourceArn)"
            />
          </td>
          <td class="status-column">
            <resource-status-pill [status]="resource.status"></resource-status-pill>
          </td>
          <td class="res-name-column">{{ resource.targetResourceName }}</td>
        </tr>
      }
    </table>
  </div>

  <table id="unquarantine-controls" class="margin-top default-padding full-width">
    <tr>
      <td class="info-column">{{ selectedResourceCount }} selected resources will be unquarantined.</td>
      <td class="info-spacer"></td>
      <td class="select-column">
        <input
          id="select-all"
          class="arpio-checkbox"
          type="checkbox"
          (input)="toggleAllResources()"
          [checked]="allResourcesChecked"
        />
        <label class="half-margin-left" for="select-all">Select all</label>
      </td>
    </tr>
    <tr [hidden]="!isUncleanResourceSelected">
      <td class="info-column" colspan="3">
        <div class="flex-left-column full-width">
          <p class="error">Warning: You have selected infected or unscanned resources to release from quarantine.</p>
        </div>
        <div class="flex-center-row full-width">
          <div>To acknowledge, type "I understand":</div>
          <input id="i-understand" class="margin-left arpio-input spacer" (keyup)="toggleUnderstand($event)" />
        </div>
      </td>
    </tr>
  </table>

  <div class="modal-footer">
    <button class="arpio-secondary-button" (click)="closeDialog()" [disabled]="loading">Cancel</button>
    <button
      busy-button
      id="failback-button"
      class="arpio-button"
      [busy]="loading"
      [disabled]="!unquarantineAllowed || loading"
      (click)="onUnquarantineClick()"
    >
      Unquarantine
    </button>
  </div>
</div>
